<div *ngIf="getServiceLevel() as serviceLevel" fxLayout="column">
    <p>{{ getName(serviceLevel) }}</p>
    <p class="period-name">{{ getPeriodName(serviceLevel) }}</p>
</div>
